// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1wxiR","inner":"Footer_inner__35DeL","nextIcon":"Footer_nextIcon__3Fu2s","innerLeft":"Footer_innerLeft__1o7Ra"};